import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// core components
import Header from "../../components/header/header";
import Footer from "../../components/footer/footer";
import AboutUsBanner from "../../components/AboutUs/AboutUsBanner";
// import { EmailDisclaimerPageData } from "../../common";
import { Container } from "reactstrap";
// import { HashLink as Link } from 'react-router-hash-link';

import { Link } from "react-router-dom";
// import { getIPGeoLocation } from "../../common/GeneralUtils";
import axios from "axios";

// import Loadable from "../../components/Loadable"
// const Header = Loadable(
//     lazy(() => import('../../components/header/header'))
// )
// const Footer = Loadable(
//     lazy(() => import('../../components/footer/footer'))
// )
// const AboutUsBanner = Loadable(
//     lazy(() => import('../../components/AboutUs/AboutUsBanner'))
// )

const EmailDisclaimerScreen = () => {
    // const location = useLocation();
    const [EmailDisclaimerPageData, setData] = useState({});
    // const [geoLocationData, setGeoLocationData] = useState(null);

    const getAllEmailDisclaimerPageData = async () => {
        try {
            const res = await axios.get('/staticDataFiles/emailDisclaimerPageData.json');
            setData(res.data);
        } catch (err) {
            console.error('Error fetching blogs:', err);
        }
    }

    useEffect(() => {
        // getIPGeoLocation(location.pathname);
        getAllEmailDisclaimerPageData();
    }, [])

    return (
        <div id="main-wrapper">
            <Header />
            <div className="page-wrapper privacy-policy-page-wrapper">
                <div className="container-fluid">
                    <div className="page-content-top">
                        <AboutUsBanner bannerImg={EmailDisclaimerPageData?.bannerImg} data={EmailDisclaimerPageData?.headerData} />
                        <section className="privacy-policy-page-wrapper">
                            <Container>
                                <div className="content">
                                    {EmailDisclaimerPageData?.aboutText?.title && <h2 className="title m-t-0">{EmailDisclaimerPageData?.aboutText?.title}</h2>}
                                    {EmailDisclaimerPageData?.aboutText?.textData.map((item, index) => <div key={index} className="first-content">
                                        {item?.paragraph && <p style={{ fontWeight: `${index === 0 ? '600' : 'normal'}` }}>{item?.paragraph} {item?.link && <Link className="link" to={item?.link} >{item?.link}</Link>} {item?.paragraph1}</p>}
                                    </div>)}
                                </div>
                                <div className="footer-content-my">
                                    <h1>{EmailDisclaimerPageData?.aboutText?.footerTitle}</h1>
                                </div>
                            </Container>
                        </section>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

EmailDisclaimerScreen.propTypes = {
    classes: PropTypes.object
};

export default EmailDisclaimerScreen;
